import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { useTranslations } from '../i18n/translations';
import { HeroLeadForm } from './HeroLeadForm';
export function HeroSection() {
  const {
    lang
  } = useLanguage();
  const t = useTranslations(lang);
  return <section className="relative overflow-hidden bg-navy-50" data-id="element-1001" data-mp="28tcwfplg451h">
      <div className="absolute inset-0 overflow-hidden" data-id="element-1002" data-mp="2wjpazjb75011">
        <div className="absolute -top-40 -right-40 w-[700px] h-[700px] rounded-full bg-primary-200/25 blur-3xl hidden sm:block" data-id="element-1003" data-mp="2wk8tp28o7sg4" />
        <div className="absolute top-1/2 -left-20 w-[500px] h-[500px] rounded-full bg-primary-300/15 blur-3xl hidden sm:block" data-id="element-1004" data-mp="30n55oa3pgqb3" />
        <div className="absolute bottom-0 right-1/3 w-[400px] h-[400px] rounded-full bg-cyan-200/20 blur-3xl hidden sm:block" data-id="element-1005" data-mp="2rsh0ejy4r8ma" />
        <div className="absolute top-1/4 right-1/4 w-[300px] h-[300px] rounded-full bg-indigo-200/10 blur-3xl hidden lg:block" data-id="element-1006" data-mp="3fht79d5zj4lf" />
        <div className="absolute inset-0 opacity-[0.025]" style={{
        backgroundImage: `linear-gradient(rgba(15,23,42,1) 1px, transparent 1px), linear-gradient(90deg, rgba(15,23,42,1) 1px, transparent 1px)`,
        backgroundSize: '60px 60px'
      }} data-id="element-1007" data-mp="3kbe8rf6segpd" />
        <motion.div animate={{
        y: [0, -20, 0],
        rotate: [0, 5, 0]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-32 right-[15%] w-16 h-16 border-2 border-primary-300/30 rounded-2xl hidden md:block" data-id="element-1008" data-mp="2p7elq1x3kma3" />
        <motion.div animate={{
        y: [0, 15, 0],
        rotate: [0, -8, 0]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute bottom-40 left-[10%] w-12 h-12 bg-primary-400/10 rounded-full hidden md:block" data-id="element-1009" data-mp="3834mxmx7hemx" />
        <motion.div animate={{
        y: [0, -12, 0]
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 2
      }} className="absolute top-1/2 right-[8%] w-8 h-8 border-2 border-cyan-300/25 rounded-lg rotate-45 hidden lg:block" data-id="element-1010" data-mp="38tupj0ehkgyb" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16 w-full" data-id="element-1011" data-mp="3rs71sv0p26y4">
        <div className="max-w-4xl" data-id="element-1012" data-mp="3rqcpg53hnn5n">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-1013" data-mp="l491z57jsls">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 text-sm font-semibold text-primary-700 bg-primary-100/80 rounded-full border border-primary-200/60 shadow-sm" data-id="element-1014" data-mp="edao1hwmjtjn">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse" data-id="element-1015" data-mp="ja14458fip52" />
              {t.hero.badge}
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="mt-6 text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-navy-900 tracking-tight leading-[1.08] text-balance" data-id="element-1016" data-mp="1yua99rbcv625">
            {t.hero.h1_1}
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mt-5 text-lg sm:text-xl text-navy-500 leading-relaxed max-w-2xl" data-id="element-1017" data-mp="2drkewk1bhhpy">
            {t.hero.subtitle}
          </motion.p>
        </div>

        {/* Horizontal lead form */}
        <div className="mt-6 lg:mt-8" data-id="element-1018" data-mp="2q20nedgwixv1">
          <HeroLeadForm data-id="element-1019" data-mp="2q31y2gu09ic8" />
        </div>
      </div>
    </section>;
}